import React from 'react';

const PageLoading = () => {
  return (
    <div className="page-loading">
      <div className="bg-inner" />
      <div className="lds-dual-ring" />
    </div>
  );
};

export default PageLoading;
